/* eslint-disable no-console */
import axios from 'axios';

import {API_BASE_URL, API_ENDPOINT_JSON} from '../../../config';
import useUserStore from '../../../store/userStore/userStore';
import {APIType, APITypeEnum} from '../../interface/tableAPIType';
import {getRouteIP, tableAPIMethod} from '../../utils/tableAPIMethod';

const stakeholderTypeAPI = async (
  type: APIType,
  data: any = undefined,
  id: string
): Promise<any> => {
  const token = useUserStore.getState().userToken;

  try {
    const response = await axios.request({
      method: tableAPIMethod(type),
      url: `${API_BASE_URL}${
        API_ENDPOINT_JSON.stakeHolderTracking
      }/${getRouteIP(type, id)}`,
      headers: {
        Authorization: `Bearer ${token}`
      },
      params: {},
      data: data ?? {}
    });

    if (type === APITypeEnum.GET_ALL) {
      return response.data.data ?? [];
    } else {
      return response.data.data;
    }
  } catch (err) {
    console.log('err:', err);
  }
};

export default stakeholderTypeAPI;
